/**
 * A LEI DO CHIP, POR PRODUTO — fonte única.
 *
 * ⚠️ Estas listas têm irmãs no banco: `fn_produto_tem_chip()` e
 * `fn_produto_exige_ativacao_chip()`, lidas pelo gatilho que normaliza o chip e
 * pelo validador que cobra campo obrigatório. Em 23/09/2026 elas estavam
 * desencontradas — o gatilho apagava, o validador cobrava, e nenhum pedido de
 * TT conseguia ser enviado ao BKO. Mudou aqui, muda lá.
 *
 * ⚠️ E têm o espelho CPF: o catálogo da Prime Conecta repete cada produto com o
 * sufixo ` CPF`, e os nomes NÃO são cópia exata (`TT PRE-PJ` vira `TT PRÉ CPF`,
 * `RENOVAÇAO` vira `RENOVAÇÃO CPF`). Até 23/09/2026 o segmento CPF estava fora
 * das duas leis: HA/PN CPF nasciam com o legado 'e-sim' — o "classifica depois"
 * que para o ciclo de Qualidade — e TT/renovação CPF carregariam chip.
 * Produto novo entra nas DUAS listas, CNPJ e CPF.
 */

/** Linha que já é do cliente: mantém o número e o mesmo chip. Não há o que classificar. */
const SEM_CHIP = [
  'TT POS-PJ', 'TT PRE-PJ', 'TT PJ - PJ', 'RENOVAÇAO', 'RENOVAÇÃO', 'RENOVACAO',
  // espelho CPF (Prime Conecta)
  'TT POS-PJ CPF', 'TT PRÉ CPF', 'TT PRE CPF', 'TT PJ - PJ CPF',
  'RENOVAÇÃO CPF', 'RENOVAÇAO CPF', 'RENOVACAO CPF',
];

/**
 * Chip novo, e o consultor escolhe qual NO PEDIDO: ESIM - REAL ou ESIM - SIMCARD.
 * Nasce vazio e o fechamento cobra — nunca o legado 'e-sim' (Douglas 22/09/2026).
 */
const EXIGE_ATIVACAO = [
  'HA NOVO', 'HA INCREMENTO', 'PN NOVO', 'PN INCREMENTO',
  // espelho CPF (Prime Conecta)
  'HA NOVO CPF', 'HA INCREMENTO CPF', 'PN NOVO CPF', 'PN INCREMENTO CPF',
];

const normalizar = (nome?: string | null) => (nome || '').trim().toUpperCase();

export function produtoTemChip(nome?: string | null): boolean {
  return !SEM_CHIP.includes(normalizar(nome));
}

/** Escopo explícito: TT, renovação e outras famílias não passam por troca de chip. */
export function produtoExigeAtivacaoChip(nome?: string | null): boolean {
  return EXIGE_ATIVACAO.includes(normalizar(nome));
}
